import { Auth, API, graphqlOperation } from 'aws-amplify';
import { listUserByUpdatedAt as ListUserByUpdatedAt } from './queries';

/**
 * ログイン中のユーザ（owner）が管理する User 一覧を取得する。
 * デフォルトでは全件取得（all = true）。
 */
export async function fetchMyUsers(all = true, pageLimit = 200) {
  // Cognito ユーザ名を取得（デフォルト設定ならこれが User.owner に入る）
  const me = await Auth.currentAuthenticatedUser();
  const owner = me.getUsername();

  let users = [];
  let nextToken = null;

  do {
    const resp = await API.graphql(
      graphqlOperation(ListUserByUpdatedAt, {
        owner,
        sortDirection: 'DESC',
        limit: pageLimit,
        nextToken,
      })
    );

    const data = resp?.data?.listUserByUpdatedAt;
    users = users.concat(data?.items ?? []);
    nextToken = data?.nextToken ?? null;
  } while (all && nextToken);

  return users; // [{ id, username, companyName, ... }, ...]
}
